/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  ChangePasswordDTO,
  PasswordsControllerOldForgotPasswordOldV1Params,
  PasswordsControllerOldResetUserPasswordOldV1PathParameters,
  ResetPasswordOldDTO,
} from '../models';

@Injectable({ providedIn: 'root' })
export class PasswordsOldService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Send password reset instructions via email
   */

  forgotPasswordOld<TData = void>(params: PasswordsControllerOldForgotPasswordOldV1Params): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/forgot-password`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Change the logged-in user’s password
   */

  changePasswordOld<TData = void>(changePasswordDTO: ChangePasswordDTO): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/change-password`, changePasswordDTO);
  }
  /**
   * @summary Reset user password using reset token
   */

  resetPasswordOld<TData = void>(resetPasswordOldDTO: ResetPasswordOldDTO): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/reset-password`, resetPasswordOldDTO);
  }
  /**
   * @summary Admin resets a user password
   */

  resetUserPasswordOld<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    userId,
  }: PasswordsControllerOldResetUserPasswordOldV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/clients/v1/clients/${clientId}/users/${userId}/reset-password`);
  }
}
